<template>
  <BaseCustomizeMetal componentCode="N" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalN",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 135px;
    left: 118px;
    @include betweenTableTablePro {
      top: 97px;
      left: 68px;
    }
    @include table {
      top: 78px;
      left: 43px;
    }
    @include phone {
      top: 66px;
      left: 29px;
    }
  }
  .templeName {
    height: 28px;
    width: 223px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 263px;
    height: 53px;
    .textContainer {
      width: 263px;
    }
  }
  .gift {
    width: 178px;
    height: 32px;
    margin: 0 17px auto auto;
    .textContainer {
      width: 178px;
    }
  }
  .respect {
    width: 46px;
    position: absolute;
    bottom: 3px;
    left: 15px;
  }
}
</style>
